export default "__VITE_ASSET__D0UlgRBx__"